import { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ApartmentViewContext } from '../context/ApartmentViewContext';
import styles from '../../../styles/aprt.module.scss';

import { AVAILABILITY_STATUS } from '../../../constants/availabilityStatus';

const { AVAILABLE, SOLD, RESERVED, UNKNOWN } = AVAILABILITY_STATUS;

function InfoListItem({ label, value }) {
  const { t } = useTranslation();
  const { setInfoTooltipData } = useContext(
    ApartmentViewContext
  );
  const infoButtonRef = useRef(null);
  // const { capitalizeFirstWord } = utilityFunctions();
  // const formattedLabel = capitalizeFirstWord(label);

  const getDisplayValueAndFlags = (label, value) => {
    switch (label) {
      case t('area'):
        return { displayValue: `${value} m`, isArea: true };
      case t('insolation'):
        return { displayValue: `${value} h`, isInsolation: true };
      case t('sun_hours'):
        return { displayValue: value, isSunHours: true };
      case t('exposition'):
        return { displayValue: value, isExposition: true }; //TODO: split value sting by ', '
      case t('windows'):
        return { displayValue: `${value}`, isWindows: true };
        case t('availability'):
        return { displayValue: t(value), isAvailability: true };
      default:
        return { displayValue: value };
    }
  };

  const {
    displayValue,
    isArea,
    isExposition,
    isInsolation,
    isSunHours,
    isWindows,
    isAvailability,
  } = getDisplayValueAndFlags(label, value);

  const handleInfoHover = (str) => {
      if (infoButtonRef.current) {
          const rect = infoButtonRef.current.getBoundingClientRect();
          const position = {
              top: rect.top,
              bottom: rect.bottom,
              left: rect.left,
              right: rect.right,
              width: rect.width,
              height: rect.height
          };

          str === null
              ? setInfoTooltipData({ type: '', hovered: false, position: null })
              : setInfoTooltipData({ type: str, hovered: true, position });
      }
  };

  const availabilityStatusStyle = (status) => {
    switch (status) {
      case SOLD:
        return 'state-sold';
      case RESERVED:
        return 'state-reserved';
      case AVAILABLE:
        return 'state-available';
      case UNKNOWN:
        return '';
      default:
        return '';
    }
  };

  const renderTooltipButton = (infoType) => {
    return (
      <button
        ref={infoButtonRef}
        className={styles.infoToolTip__button}
        onMouseEnter={() => handleInfoHover(infoType)}
        onMouseLeave={() => handleInfoHover(null)}
      >
        ?
      </button>
    );
  };

  return (
    <div className={styles.list__row}>
      <dt className={styles.infoList__dt}>
        {`${label}`}
        {isInsolation && renderTooltipButton(t('insolation'))}
        {isExposition && renderTooltipButton(t('exposition'))}
        {isWindows && renderTooltipButton(t('windows'))}
        {`:`}
      </dt>
      <dd className={`${styles.infoList__dd} ${isAvailability ? availabilityStatusStyle(value) : ""}`}>
        {displayValue}
        {isArea ? <sup>2</sup> : ''}
      </dd>
    </div>
  );
}

export default InfoListItem;
